import { render, staticRenderFns } from "./CareerYagiofferEduHistoryCard.vue?vue&type=template&id=65bce846"
import script from "./CareerYagiofferEduHistoryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CareerYagiofferEduHistoryCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports